import { render, staticRenderFns } from "./Book1.vue?vue&type=template&id=5394acb7&scoped=true&"
import script from "./Book1.vue?vue&type=script&lang=js&"
export * from "./Book1.vue?vue&type=script&lang=js&"
import style0 from "./Book1.vue?vue&type=style&index=0&id=5394acb7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5394acb7",
  null
  
)

export default component.exports